import React from 'react';
import RootOfStages from './RootOfStages';
import NotFound from '../../../../assets/0-items.png';
import funcTranslateHelper from '../../../../i18next/funcTranslateHelper';

function DashboardBuilderStages ({ configFile, setConfigFile, setOpenNotication }) {
  return (
    <div className='main-content'>
      {!configFile || !configFile.stages ? (
        <div className='box-not-found'>
          <div className='content-not-found'>
            <img src={NotFound} className='img-not-found' alt='Items not found' width='40%' />
            <p className='txt-not-found'>{funcTranslateHelper('notResult')}</p>
          </div>
        </div>
      ) : (
        <div className='bx--row dashboard-box'>
          {configFile.stages.map((stage, i) => (
            <div className='bx--col column-mw' key={i}>
              <RootOfStages
                key={i}
                stages={stage}
                configFile={configFile}
                setConfigFile={setConfigFile}
                setOpenNotication={setOpenNotication}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default DashboardBuilderStages;
